export const Logo = ({ size = 30 }) => (
  <svg
    width={size}
    height={size * 0.6}
    viewBox="0 0 40 24"
    fill="none"
    aria-hidden="true"
    style={{ display: "block" }}
  >
    <path
      d="M2 19 C8 19 12 16 16 13 C20 9.5 24 8 28 8 C32 8 34.5 10.5 35.5 13 C36.2 14.8 36 17 35 18"
      stroke="url(#ishu-g)"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="9" cy="18.5" r="2.4" stroke="#E6B800" strokeWidth="1.7" fill="none" />
    <circle cx="28" cy="18.5" r="2.4" stroke="#E6B800" strokeWidth="1.7" fill="none" />
    <defs>
      <linearGradient id="ishu-g" x1="0" y1="0" x2="40" y2="24">
        <stop stopColor="#FFC700" />
        <stop offset="1" stopColor="#9BA1AD" />
      </linearGradient>
    </defs>
  </svg>
);

export const Wordmark = ({ size = 30, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <Logo size={size} />
    <span className="inline-flex flex-col leading-none">
      <span className="font-display text-xl font-bold tracking-tight">
        <span className="text-[#e8e9ed]">Ishu</span>
        <span className="text-gold-gradient">Car</span>
      </span>
      <span className="mt-1.5 font-mono2 text-[9px] uppercase tracking-[0.28em] text-neutral-500">
        by IshuKart
      </span>
    </span>
  </span>
);